// Mock SMS/WhatsApp dispatcher — keeps the same public shape it had pre-
// migration so call-sites don't need to change. The backend is now the
// source of truth for templates; the customer's "Order Placed" notification
// fires automatically inside POST /api/orders on the server. This helper is
// only used for ad-hoc events triggered by the frontend (e.g. abandoned cart).
import { apiNotify } from "@/lib/api";

export const sendNotification = async ({
  templateId,
  to,
  variables = {},
  metadata = {},
  channel = "sms+whatsapp",
}) => {
  return apiNotify({
    template_id: templateId,
    event: metadata.event || templateId,
    to,
    channel,
    variables,
    metadata,
  });
};

// Back-compat shim — older code calls this after placing an order. The
// backend now auto-fires the "Order Placed" template inside POST /api/orders,
// so this is a no-op that resolves to {ok:true} to avoid breaking callers.
export const sendOrderPlacedNotification = async ({ phone, order }) => {
  return {
    ok: true,
    to: phone ? `+91${String(phone).replace(/^\+?91/, "")}` : "",
    serverDispatched: true,
    orderId: order?.id || null,
  };
};

export const sendAbandonedCartNotification = async ({ phone, name }) =>
  sendNotification({
    templateId: "MB_ABANDONED_CART_V1",
    to: phone,
    variables: { customer_name: name || "there" },
    metadata: { event: "cart.abandoned" },
  });
